export const contactsData = {
    email: 'Sudhanshuk384@gmail.com',
    phone: '+91 7352692258',
    address: 'Bengaluru, Karnataka ',

    sheetAPI: 'https://sheetdb.io/api/v1/kyjyab0hlo19s'
}